export default __webpack_public_path__ + "static/fmcg-25e1f5d45f4a005f4790c9cd91f6de03.png";